export const addressSchema = (yup) => {
  return {
    url: yup.string().required("required"),
    name: yup.string().required("required"),
    latitude: yup.string().required("required")
  };
};

export const addressInitial = {
  url: "",
  name: "",
  latitude: "",
};
